import * as CONSTANT from './../base/constant';
import { InsertHtml } from './inserthtml';
import * as EVENTS from './../../common/constant';
import { closest } from '@syncfusion/ej2-base';
/**
 * Selection EXEC internal component
 *
 * @hidden
 * @private
 */
export class InsertHtmlExec {
    /**
     * Constructor for creating the Formats plugin
     *
     * @param {EditorManager} parent - sepcifies the parent element
     * @hidden
     * @private
     */
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(CONSTANT.INSERTHTML_TYPE, this.applyHtml, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(CONSTANT.INSERTHTML_TYPE, this.applyHtml);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    }
    applyHtml(e) {
        const selectionRange = this.getSelectionRange();
        const element = e.value;
        const firstChild = element.firstChild;
        if (firstChild && firstChild.nodeName === 'A' && selectionRange.startOffset !== selectionRange.endOffset) {
            const isTextNode = selectionRange.startContainer.nodeName === '#text';
            const notifyType = isTextNode ? CONSTANT.LINK : CONSTANT.IMAGE;
            const actionType = isTextNode ? 'CreateLink' : 'InsertLink';
            this.parent.observer.notify(notifyType, {
                value: actionType,
                item: this.extractHyperlinkDetails(e),
                callBack: e.callBack
            });
        }
        else {
            InsertHtml.Insert(this.parent.currentDocument, e.value, this.parent.editableElement, true, e.enterAction, this.parent);
        }
        if (e.subCommand === 'pasteCleanup') {
            const pastedElements = this.parent.editableElement.querySelectorAll('.pasteContent_RTE');
            const allPastedElements = [].slice.call(pastedElements);
            const imgElements = this.parent.editableElement.querySelectorAll('.pasteContent_Img');
            const allImgElm = [].slice.call(imgElements);
            e.callBack({
                requestType: e.subCommand,
                editorMode: 'HTML',
                elements: allPastedElements,
                imgElem: allImgElm
            });
        }
        else {
            if (e.callBack) {
                e.callBack({
                    requestType: e.subCommand,
                    editorMode: 'HTML',
                    event: e.event,
                    range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                    elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
                });
            }
        }
    }
    extractHyperlinkDetails(e) {
        let selectedText;
        const selectionRange = this.getSelectionRange();
        const selection = this.parent.nodeSelection;
        const parentNodes = selection.getParentNodeCollection(selectionRange);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const anchor = e.value.querySelector('a');
        const anchorElement = this.findAnchorElement(parentNodes);
        if (anchorElement && anchorElement.nodeName === 'A') {
            const rangeText = selectionRange.toString();
            const anchorText = anchorElement.innerText;
            selectedText = (rangeText.length < anchorText.length) ? anchorText : rangeText;
        }
        else {
            selectedText = selectionRange.toString();
        }
        return {
            url: anchor.href || '',
            text: selectedText,
            title: anchor.title || '',
            target: anchor.target || '',
            ariaLabel: anchor.ariaLabel || '',
            selection: this.parent.nodeSelection,
            selectNode: Array.from(this.getSelectionRange().startContainer.childNodes),
            selectParent: parentNodes
        };
    }
    getSelectionRange() {
        return this.parent.nodeSelection.getRange(this.parent.currentDocument);
    }
    findAnchorElement(nodes) {
        for (const node of nodes) {
            const anchor = closest(node, 'a');
            if (anchor) {
                return anchor;
            }
        }
        return nodes[0];
    }
    destroy() {
        this.removeEventListener();
    }
}
